import { render, staticRenderFns } from "./HeaderChatNotification.vue?vue&type=template&id=5772e407"
import script from "./HeaderChatNotification.vue?vue&type=script&lang=js"
export * from "./HeaderChatNotification.vue?vue&type=script&lang=js"
import style0 from "./HeaderChatNotification.vue?vue&type=style&index=0&id=5772e407&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports